import { useState, createContext } from 'react';

const EditDataSpaceFormContext = createContext();

export const EditDataSpaceFormContextProvider = (props) => {
	const [dataSpace, setDataSpace] = useState();
	const [selectedSport, setSelectedSport] = useState();
	const [selectedFantasyLeague, setSelectedFantasyLeague] = useState();
	const [fantasyLeagues, setFantasyLeagues] = useState();
	const [datasets, setDatasets] = useState();
	const [isFantasyLeagueToggleChecked, setIsFantasyLeagueToggleChecked] = useState(false);

	const values = {
		dataSpace,
		setDataSpace,
		selectedSport,
		setSelectedSport,
		selectedFantasyLeague,
		setSelectedFantasyLeague,
		fantasyLeagues,
		setFantasyLeagues,
		datasets,
		setDatasets,
		isFantasyLeagueToggleChecked,
		setIsFantasyLeagueToggleChecked,
	};

	return <EditDataSpaceFormContext.Provider value={values}>{props.children}</EditDataSpaceFormContext.Provider>;
};

export default EditDataSpaceFormContext;
